import React, { useEffect } from 'react';
import { Link } from '../common/Link';
import { ArrowLeft } from 'lucide-react';
import { motion } from 'framer-motion';
import { Heading } from '../typography/Heading';
import { Text } from '../typography/Text';

export function NotFound() {
  useEffect(() => {
    // Set HTTP status code to 404
    const metaTag = document.createElement('meta');
    metaTag.httpEquiv = 'status';
    metaTag.content = '404 Not Found';
    document.head.appendChild(metaTag);

    // Update document title
    document.title = '404 - Page Not Found';

    return () => {
      // Cleanup
      document.head.removeChild(metaTag);
    };
  }, []);

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4">
      <motion.div 
        className="text-center"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <div className="mb-8">
          <div className="text-9xl font-bold text-primary/10">404</div>
          <Heading level={1} align="center" className="mt-4 mb-2">
            Page Not Found
          </Heading>
          <Text size="lg" align="center" className="text-slate-light max-w-md mx-auto">
            The page you're looking for doesn't exist or has been moved.
          </Text>
        </div>

        <Link 
          href="/"
          className="inline-flex items-center px-6 py-3 text-white bg-primary rounded-full hover:bg-primary-hover transition-colors group"
        >
          <ArrowLeft className="w-4 h-4 mr-2 transform group-hover:-translate-x-1 transition-transform" />
          Back to Home
        </Link>
      </motion.div>
    </div>
  );
}